import React from "react";
import { Center, Stack } from "@mantine/core";
import { CustomText } from "../../ui/CustomText/CustomText";

const TransactionEmptyState = ({ searchQuery }) => {
  const isSearchEmpty = !!searchQuery;

  return (
    <Center h={300}>
      <Stack align="center" gap="md">
        <CustomText size="lg" fw={isSearchEmpty ? 600 : 500} c="dimmed">
          {isSearchEmpty
            ? `No results for "${searchQuery}"`
            : "No transactions have been made yet."}
        </CustomText>
        <CustomText size="sm" c="dimmed">
          {isSearchEmpty
            ? "Try different keywords (gateway reference)."
            : "Start by making a transaction to see it listed here."}
        </CustomText>
      </Stack>
    </Center>
  );
};

export default TransactionEmptyState;
